/*----------------------------------------
  CART DROPDOWN
----------------------------------------*/
$(function() {
	$(document).click(function() {
		$(".cart").removeClass("open");
		$(".cart").addClass("closed");
	});

	$( ".cart" ).click(function(e) {
		var cartHeight = $(".cart-wrapper").outerHeight();
		$(".cart-dropdown").height(cartHeight);
		$(this).toggleClass("open closed");
		e.stopPropagation();
	});
	$(".nav-link").hover(function(){
		$(".cart").removeClass("open");
		$(".cart").addClass("closed");
	});
});


/*----------------------------------------
  HOMEPAGE SLIDER
----------------------------------------*/
$(function() {
    $('.homepage-slider').unslider({
		speed: 500,               //  The speed to animate each slide (in milliseconds)
		delay: 3000,              //  The delay between slide animations (in milliseconds)
		complete: function() {},  //  A function that gets called after every slide animation
		keys: false,               //  Enable keyboard (left, right) arrow shortcuts
		dots: true,               //  Display dot navigation
		fluid: true              //  Support responsive design. May break non-responsive designs
	});

});


/*----------------------------------------
  MEGABOX LIGHTBOX
----------------------------------------*/
$(function(){
	var megaOpen = false;

	$(document).click(function() {
		$(".megabox-overlay").remove();
		megaOpen = false;
	});

	$('.icon-remove').click(function(){
		$(".megabox-overlay").remove();
		megaOpen = false;
	});

	$("a[rel*='megabox']").click(function(e){
		e.preventDefault();
		if (megaOpen != true){
			megaOpen = true;
			var megaImage = $(this).attr('href');
			var megabox = "<div class='megabox-overlay'><div class='loading-image'><img src='http://cdn.shopify.com/s/files/1/0260/5201/t/1/assets/loading.gif'/></div><div class='megabox-popup mega-hide'><i class='icon-remove'></i><img src='" + megaImage + "' class='main-image'/></div></div>";
			$('body').prepend(megabox);
			$('.megabox-overlay').delay(100);

			$('.megabox-overlay').queue(function(){
				$('.megabox-overlay').addClass('mega-show');
			});

			$('.main-image').load(function(){
  				$('.loading-image').hide();
  				$(this).hide();
  				resizeMegaBox();
			});
			e.stopPropagation();
		}
	});

	function resizeMegaBox(){
		var megaHeight = $('.main-image').height();
		var megaWidth = $('.main-image').width();
		$('.megabox-popup').width(megaWidth);
		$('.megabox-popup').height(megaHeight);
		$('.megabox-popup').css('left', $(window).width() / 2 - ($('.megabox-popup').width() / 2));
		$('.megabox-popup').css('top', $(window).height() / 2 - ($('.megabox-popup').height() / 2));
		$('.main-image').show();
		$('.megabox-popup').delay(100);
		$('.megabox-popup').queue(function(){
			$('.megabox-popup').removeClass('mega-hide').addClass('mega-show');
		});
	}


});

